import {BaseAnalyticsProvider} from "../base-analytics-provider";
import {singleton} from "../../../infrastructure/decorators/singleton";
import {BaseAnalyticsEvent} from "../../../infrastructure/models/analytics/base-analytics-event";
import {GoogleAnalyticsEventModel} from "./google-analytics-event-model";
import {APP} from "../../../core/app/consts";
import {ARGS} from "../../../core/bootstrap/args";

@singleton
export class GoogleAnalyticsProvider extends BaseAnalyticsProvider {
  name: String = APP.ANALYTICS.PROVIDERS.googleAnalytics;

  static injectables = [...BaseAnalyticsProvider.injectables];

  get defaultParams() {
    const defaultParams = {
      site_version: this.siteVersion,
      url: window.location.href,
      publisherId: this.appState.settings.publisherSettings.id,
      page: this.appState.settings.isWidget ? APP.GOOGLE_ANALYTICS.PAGES.none : APP.GOOGLE_ANALYTICS.PAGES[this.appState.currentLinkModel?.name],
      appType: this.appState.settings.isWidget ? APP.GOOGLE_ANALYTICS.APP_TYPES.widget : APP.GOOGLE_ANALYTICS.APP_TYPES.website
    }

    return defaultParams;
  }

  sendPageViewEvent(url: String) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        ...this.defaultParams
      });
    }
  }

  createEvent(event: BaseAnalyticsEvent, force: Boolean) {
    const newEvent: GoogleAnalyticsEventModel = event?.googleAnalyticsEvent;
    const sendEvent: Boolean = window.dataLayer && (!!event.googleAnalyticsEvent || force);

    if (sendEvent) {
      window.dataLayer.push({
        ...newEvent,
        ...this.defaultParams
      });
    }
  }

  get siteVersion() {
    return ARGS.VERSION_NUMBER;
  }
}
